function e(e,n){if(e==null)return{};var r={};var t=Object.keys(e);var f,u;for(u=0;u<t.length;u++){f=t[u];if(n.indexOf(f)>=0)continue;r[f]=e[f]}return r}export{e as default};
//# sourceMappingURL=objectWithoutPropertiesLoose.js.map
